export function getClientLanguage(): string {
  return 'en-US';
  // if (typeof navigator === 'undefined') return 'en-US';
  // return navigator?.language ?? 'en-US';
}
